import './News.css';
import { Box } from '@mui/material';
import NewsSlide from '../../components/Slides/News/NewsSlide';
import { useEffect, useLayoutEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { BeatLoader } from 'react-spinners';

const News = () => {
  const [isLoading, setIsLoading] = useState(true);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);

    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute('color-scheme', 'dark');
  })

  useEffect(() => {
    const mediaElements = Array.from(document.querySelectorAll("img, video"));
    let loadedCount = 0;

    const checkAllLoaded = () => {
      loadedCount++;
      if (loadedCount === mediaElements.length) {
        setIsLoading(false);
      }
    };

    if (mediaElements.length === 0) {
      setIsLoading(false);
    } else {
      mediaElements.forEach((el) => {
        if (el instanceof HTMLImageElement && el.complete) {
          checkAllLoaded();
        } else if (el instanceof HTMLVideoElement && el.readyState >= 3) {
          checkAllLoaded();
        } else {
          el.addEventListener("load", checkAllLoaded);
          el.addEventListener("error", checkAllLoaded);
        }
      });
    }

    return () => {
      mediaElements.forEach((el) => {
        el.removeEventListener("load", checkAllLoaded);
        el.removeEventListener("error", checkAllLoaded);
      });
    };
  }, []);

  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isLoading]);

  if (isLoading) {
    return (
      <div className="loading-screen">
        <BeatLoader
          color={"var(--accent-1--dark)"}
          loading={isLoading}
          size={150}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>News | Billet Precision Ltd.</title>
        <meta name="description" content="Stay updated with the latest news and innovations at Billet Precision." />
        <meta property="og:title" content="News | Billet Precision Ltd." />
        <meta property="og:description" content="Stay updated with the latest news and innovations at Billet Precision." />
        <link rel="canonical" href="https://billetprecision.ca/news" />
      </Helmet>
      <Box className="main-content" id="news-main-content">
        <NewsSlide />
      </Box>
    </>
  );
};


export default News;